/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from 'pinia';
import Axios from '@auth/vue-share/utility/axios';

export const useClaimsStore = defineStore('claims', {
    state: () => ({
        claims: undefined
    }),
    getters: {
        getClaims: (state) => state.claims
    },
    actions: {
        fetchClaims() {
            Axios.get('claim/claims', '/api/claims').then((response) => {
                this.claims = response.data.data;
            });
        },
        async getClaim(identifier) {
            return Axios.get('claims/get', `/api/claims/${identifier}`);
        },
        async createClaim(client) {
            return Axios.post('claims/create', '/api/claims', client);
        },
        async updateClaim(claim) {
            return Axios.patch('claims/update', `/api/claims`, claim);
        },
        deleteClaim(identifier) {
            return new Promise((resolve, reject) => {
                Axios.delete('claims/delete', `/api/claims/${identifier}`)
                    .then(() => {
                        const index = this.claims.findIndex((claim) => claim.identifier === identifier);

                        if (index !== -1) this.claims.splice(index, 1);

                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
});
